import {UniqueIdService} from '../../../shared/services/unique-id.service';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IReportItemComponent } from "../../models/i-report-item-component";
import { AssessmentResult } from "../../../shared/models/assessment-result";
import {Variable} from "../../models/variable";
import {ViewEncapsulation, ElementRef} from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { ReportNavigationItem } from 'app/reports/models/report-navigation-item';
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';
@Component({
  selector: 'app-html-content-item',
  templateUrl: './html-content-item.component.html'
  ,encapsulation: ViewEncapsulation.None
})
export class HtmlContentItemComponent extends BaseReportItemComponent implements OnInit, IReportItemComponent {

  private _content:SafeHtml;
  @Input("data") public data:any;
  @Input("data") public results:AssessmentResult[];
  private _itemId:string;
  private _classNames = [];

  constructor(private domSanitizer:DomSanitizer) { 
    super();
  }

  public getHTMLClassNames() : string[] {
    return this._classNames;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    if (data && data.content) {
      var content = data.content as string;
      
      if (variables && variables.length) {
        // handle any variable substitutions here...
        variables.forEach(v => {
          let id:string = "{{" + v.id + "}}";
          let replace = v.value + "";
          content = content.replace(id, replace);
        });
      }
      this.content = this.domSanitizer.bypassSecurityTrustHtml(content);
      if (data.classNames && data.classNames.length) {
        this._classNames = data.classNames.concat(this._classNames);
      }
    }
  }

  get content() {
    return this._content;
  }

  set content(v:SafeHtml) {
    this._content = v;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/html-content-item/html-content-item.component.ts